<template>
    <div class="cons">
        <div class="bread">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item style="cursor: pointer;" @click.native="handleBack">求职招聘</el-breadcrumb-item>
                <el-breadcrumb-item>{{info.name}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="cns">
            <div class="cntop flx alc jsb">
                <div class="cntleft">
                    <div class="cll flx alc">
                        <div class="rename" v-text="info.name"></div>
                        <div class="resalary" v-if="info.salary_mix > 0 && info.salary_max > 0" v-text="`${info.salary_mix}K ~ ${info.salary_max}K`"></div>
                        <div class="resalary" v-else>面议</div>
                    </div>
                    <div class="cbb flx alc">
                        <div class="cbitem" v-text="info.city_name"></div>
                        <div class="shu">
                        </div>
                        <div class="cbitem" v-text="info.exp_name"></div>
                        <div class="shu">
                        </div>
                        <div class="cbitem" v-text="info.eb_name"></div>
                    </div>
                </div>
                <div class="cntright flx alc">
                    <div class="colbtn cursor flx alc" @click="collthis">
                        <img :src="$Localimg('lanshoucang.png')" alt="" />
                        <div class="colname" v-text="info.collect_status == 0?'收藏' : '已收藏'"></div>
                    </div>
                    <div class="sendjl cursor" @click="show = true" v-if="info.resume_status == 0">
                        投递简历
                    </div>
                    <div class="sendjl cursor" v-if="info.resume_status == 1" style="opacity: 0.6;">
                        已投递简历
                    </div>
                </div>
            </div>

            <div class="pointro">
                <div class="potite">
                    <div class="poname">
                        职位详情
                    </div>
                    <div class="pobk"></div>
                </div>
                <div class="poContent" v-text="info.content"></div>
            </div>

            <div class="pointro">
                <div class="potite">
                    <div class="poname">
                        公司信息
                    </div>
                    <div class="pobk"></div>
                </div>
                <div class="companyinfo flx alc jsb cursor">
                    <div class="cileft flx alc">
                        <img :src="$img(info.shop_avatar)" alt="" />
                        <div class="" flx>
                            <div class="comname" v-text="info.shop_name"></div>
                            <!-- <div class="conma" v-text="`${info.shop_people}·${info.shop_label}`"></div> -->
                        </div>
                    </div>
                    <div class="ciright">
                        <span style="font-weight: 600;font-size: 28px;color: #007AFF;margin-right: 4px;"
                            v-text="info.shop_job_num"></span>个在招职位
                    </div>
                </div>

                <div class="comintros">
                    <div class="innerTitle">
                        公司介绍
                    </div>
                    <div class="lcocjk" v-text="info.shop_intro">

                    </div>
                    <div class="cheall flx alc" @click="tocompany">
                        查看全部信息
                        <i class="el-icon-caret-right" style="color: #9399AD;"></i>
                    </div>
                </div>

            </div>

            <div class="pointro jb">
                {{notes}}<span @click="jb"
                    style="color: #007AFF;text-decoration: underline;cursor: pointer;">请立即举报</span>
            </div>
        </div>
        <div class="mask" v-if="show">
            <div class="maskContent" v-if="resume != '' && ups == false">
                <div class="mttitle">
                    确认发送简历吗?
                </div>
                <div class="subTitle">
                    简历将直接发送至企业后台
                </div>
                <div class="mbtns flx alc jsb">
                    <div class="mbttns" @click="show = false">
                        取消
                    </div>
                    <div class="mbttns1" @click="sendjl">
                        确定
                    </div>
                </div>
            </div>

            <div class="maskContent" v-if="resume == '' && ups == false">
                <div class="mttitle" style="padding-top: 0;">
                    温馨提示
                </div>
                <div class="subTitle">
                    您暂时还没有附件简历，是否去上传简历?
                </div>
                <div class="mbtns flx alc jsb">
                    <div class="mbttns" @click="show = false">
                        取消
                    </div>
                    <div class="mbttns1" @click="ups = true">
                        确定
                    </div>
                </div>
            </div>


            <div class="upjl" v-if="ups == true">
                <div class="upsTitle flx alc jsb">
                    <span>上传简历</span>
                    <i class="el-icon-close" @click="show = false"></i>
                </div>
                <el-upload class="upload-demo" style="width: 100%;" action="https://two.hrxsl.com/api/Common/oss_upload"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="uploadHeaders"
                    :show-file-list="false">
                    <div class="upp">
                        <div class="upp1">
                            点击上传文件，快速上传
                        </div>
                        <div class="upp2">
                            请上传DOC、DOCX、PDF格式的中文简历，大小不超过20M
                        </div>
                        <div class="flx alc jsc">
                                <el-button style="margin: 55px auto 0;" size="small" type="primary">上传文件</el-button>
                        </div>
                    </div>
                </el-upload>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getRecruDetail,
        collecthr,
        userInfo,
        edituser,
        sendjl,
        getConfig
    } from "@/api/index.js"
    export default {
        name: "index",
        data() {
            return {
                info: {},
                resume: '',
                ups: false,
                show:false,
                notes:"",
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
            };
        },
        watch: {
          $route: {
            handler(to, from) {
             this.id= to.query.id
             this.getDetail()
            },
            deep: true
          }
        },
        created() {
            this.getDetail()
            let token = localStorage.getItem('token')
            if(token){
                userInfo().then((res) => {
                    console.log("user", res)
                    this.resume = res.data.resume
                })
                getConfig().then((res) => {
                    console.log("config",res)
                    if(res.code == 1){
                        this.notes = res.data.job_note
                    }
                })
            }
        },
        methods: {
            jb(){
                console.log(123)
                this.$ysf('open')
            },
            handleBack() {
                if (window.history.length > 1) {
                    this.$router.back()
                } else {
                    this.$router.push('/')
                }
            },
            beforeAvatarUpload(file) {
                console.log(file.type)
                // 1. 允许的图片格式
                const allowType = ['doc', 'pdf' ,'docx']
                // 2. 最大8MB
                const maxSize = 20 * 1024 * 1024
                 const suffix = file.name.split('.').pop().toLowerCase()
                // 校验格式
                if (!allowType.includes(suffix)) {
                    this.$message.error('仅支持 doc 和pdf 格式文件！')
                    return false
                }
            
                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('文件不能大于20MB！')
                    return false
                }
            
                // 校验通过，允许上传
                return true
            },
            sendjl(){
                let that = this 
                let data = {}
                data.id= that.$route.query.id
                data.resume = that.resume
                sendjl(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                        that.show = false
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            handleAvatarSuccess(e) {
                let that = this 
                console.log(e)
                if(e.code == 1){
                    let data = {}
                    data.resume = e.data.url
                    edituser(data).then((rest) => {
                        if (rest.code == 1) {
                            // that.$message.success(rest.msg)
                            that.sendjl()
                        } else {
                            that.$message.error(rest.msg)
                        }
                    })
                }else{
                     that.$message.error(e.msg)
                }
                
            },
            collthis() {
                let that = this
                collecthr(that.$route.query.id).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            getDetail() {
                let that = this
                let data = that.$route.query.id
                getRecruDetail(data).then((res) => {
                    console.log("detail", res)
                    if (res.code == 1) {
                        that.info = res.data
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            tocompany() {
                let that = this
                this.$router.push({
                    path: '/Companyhr', // 写路由path
                    query: {
                        id: that.info.shop_id
                    }
                })
            }
        }
    };
</script>


<style scoped>
    .upp2 {
        font-weight: 400;
        font-size: 13px;
        color: #999999;
        text-align: center;
    }
    .cbitem{
        font-size: 18px;
    }
    .upp1 {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        text-align: center;
        margin-bottom: 10px;
    }

    .upp {
        width: 542px;
        height: 241px;
        background: #F3F6FF;
        border-radius: 8px 8px 8px 8px;
        box-sizing: border-box;
        padding-top: 50px;
        margin-top: 14px;
    }

    .upsTitle span {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
    }

    .upjl {
        width: 582px;
        height: 330px;
        background: url('https://two.hrxsl.com/pcImages/jlbk.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        padding: 20px;
    }

    .mbtns {
        margin-top: 31px;
    }

    .mbttns1 {
        width: 108px;
        height: 36px;
        background: #007AFF;
        border-radius: 2px 2px 2px 2px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        line-height: 36px;
    }

    .mbttns {
        width: 108px;
        height: 36px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #D9D9D9;
        text-align: center;
        font-size: 14px;
        color: #999999;
        line-height: 36px;
    }

    .mttitle {
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        box-sizing: border-box;
        padding-top: 20px;
    }

    .subTitle {
        font-size: 15px;
        color: #666666;
        text-align: center;
        margin-top: 10px;
    }

    .maskContent {
        width: 274px;
        height: 183px;
        background: url('https://two.hrxsl.com/pcImages/jlbk.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        padding: 20px;
    }

    .mask {
       /* width: calc(100vw / 0.85);
        height: calc(100vh / 0.85); */
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1998 !important;
        position: fixed;
        left: 0;
        top: 0;
    }

    .jb {
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 25px;
    }

    .cheall {
        justify-content: center;
        font-weight: 500;
        font-size: 16px;
        color: #9399AD;
        margin-top: 16px;
        cursor: pointer;
    }

    .lcocjk {
        font-weight: 500;
        font-size: 14px;
        color: #4E5366;
    }

    .innerTitle {
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        margin-bottom: 16px;
    }

    .comintros {
        box-sizing: border-box;
        padding: 20px 0;
    }

    .ciright {
        font-size: 13px;
        color: #222222;
    }

    .comname {
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        line-height: 30px;
    }

    .conma {
        font-size: 13px;
        color: #222222;
        margin-top: 6px;
    }

    .cileft {}

    .cileft img {
        width: 56px;
        height: 56px;
        border-radius: 6px;
        margin-right: 15px;
    }

    .companyinfo {
        margin-top: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f0f0f0;
    }

    .poContent {
        white-space: pre-wrap;
        margin-top: 20px;
        font-size: 16px;
        color: #222222;
        line-height: 30px;
    }

    .poname {
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        z-index: 3;
        position: relative;
    }

    .pobk {
        width: 72px;
        height: 8px;
        background: linear-gradient(90deg, #BAD9FF 0%, rgba(255, 255, 255, 0) 100%);
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .potite {
        position: relative;

    }

    .pointro {
        box-sizing: border-box;
        background: #fff;
        border-radius: 10px;
        padding: 26px;
        margin-top: 16px;
    }

    .sendjl {
        width: 200px;
        height: 48px;
        background: rgba(64, 150, 255, 1);
        border-radius: 6px 6px 6px 6px;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        line-height: 48px;
    }

    .colbtn img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }

    .colbtn {
        width: 112px;
        height: 48px;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid rgba(64, 150, 255, 1);
        justify-content: center;
        color: rgba(64, 150, 255, 1);
        margin-right: 14px;
    }

    .cbb {
        margin-top: 16px;
        color: #555C70;
        font-size: 14px;
    }

    .shu {
        margin: 0 12px;
    }

    .cons {
        box-sizing: border-box;
        padding: 0;
        text-align: left;
    }

    .rename {
        font-weight: 600;
        font-size: 30px;
        color: #222222;
    }

    .resalary {
        font-weight: 500;
        font-size: 24px;
        color: #007AFF;
        position: relative;
        top: 2px;
        margin-left: 30px;
    }

    .cntop {
        width: 100%;
        box-sizing: border-box;
        padding: 26px;
        background-color: #fff;

    }

    .cns {
        width: 1460px;
        margin: 0 auto;
    }
</style>